import React from "react";
import { useTheme } from "@mui/material";
import { PeopleAltOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { dashboard2ManageColleaguesPillSx } from "../dashboard2-status.styles";
import { Dashboard2NavLink } from "./Dashboard2NavLink";

export const Dashboard2ManageColleaguesLink: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Dashboard2NavLink
      to="/connections"
      label={t("Manage colleagues")}
      ariaLabel={t("_dashboard2_manageColleaguesLinkAria")}
      testId="dashboard2-manage-colleagues-link"
      icon={<PeopleAltOutlined fontSize="small" />}
      sx={dashboard2ManageColleaguesPillSx(theme)}
      underline="none"
    />
  );
};
